import React from 'react';
import ReactDOM from 'react-dom';
import { Field,reduxForm,formValueSelector } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../../components/LoadingSmall.js';
import Dropdown from '../../../../components/ReduxForm/dropdown';

const validate = values => {
    const errors = {}

    if (!values.BCC) {
        errors.BCC = 'Required'
    }

    if (!values.REVIEW_TYPE) {
        errors.REVIEW_TYPE = 'Required'
    }

    if (values.REVIEW_TYPE == '' || values.REVIEW_TYPE == '0') {
        errors.REVIEW_TYPE = 'Required'
    }

    return errors
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

class TrustPilot extends React.Component {
    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                {this.props.err ?
                    <div className="alert dark alert-icon alert-danger alert-dismissible" role="alert">
                        <i className="icon wb-close" aria-hidden="true"></i>
                        {this.props.err}
                    </div>
                    :null}
                <div className="row">
                    <div className="col-sm-12">
                        <Field component={renderField} type="text" name="BCC" placeholder="" title="Trustpilot BCC e-mail" className="form-control" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <Field component={Dropdown} placeholder="Select invitation type" name="REVIEW_TYPE"
                               initialValue="PRODUCT"
                               options={[
                                   {
                                       label:'Product invitation',
                                       value:'PRODUCT'
                                   },
                                   {
                                       label:'Service invitation',
                                       value:'SERVICE'
                                   },
                               ]} title="Invitation type" />

                        {
                            this.props.REVIEW_TYPE == 'PRODUCT' ?
                            <div className="alert alert-primary" role="alert">
                                <strong>Important</strong>: Product invitations is only available on Trustpilot <strong>PRO</strong> and <strong>Enterprise</strong> plans. The <strong>free</strong> and <strong>lite</strong> plan only supports Service invitations.
                            </div>:null
                        }
                    </div>
                </div>

                <div className="row m-t-20">
                    <div className="col-sm-12">
                        {
                            this.props.isWaiting
                                ?
                                <LoadingSmall />
                                :
                                <button type="submit" className="btn btn-dark btn-block">{this.props.app.installed ? 'Update':'Install'}</button>
                        }
                    </div>
                </div>


            </form>
        );
    }
}

const selector = formValueSelector('TrustPilot');

// Decorate the form component
TrustPilot = reduxForm({
    form: 'TrustPilot',
    validate,
})(TrustPilot);

TrustPilot = connect(
    state => ({
        REVIEW_TYPE:selector(state, 'REVIEW_TYPE'),
    })
)(TrustPilot)

export default TrustPilot;


// WEBPACK FOOTER //
// ./containers/apps/apps/forms/TrustPilot.js